import { useEffect, useState } from "react";
import React from "react";
import { useRecoilState } from "recoil";
import { App, Layout } from 'antd';
import { Authenticator,
  ThemeProvider,
  // useTheme,
  defaultDarkModeOverride,
  useAuthenticator,
 } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import {
    UserOutlined
} from "@ant-design/icons";
import "./App.css";
import NavBar from "./Components/NavBar";
import SideBar from "./Components/SideBar";
import PageContent from "./Components/PageContent";
import MobileMenu from "./Components/MobileMenu";
import { allSitesAtom } from "./Atoms/allSitesAtom";
import { getRecipientShares, getTools, getUsers,updateRecipient,getMessages } from "./API";
import { Row, Text, View, Icon, Graph, Alert, Button} from "./Components"
import AppRoutes from "./Components/AppRoutes";
import { withCookies } from "react-cookie";
import _ from 'lodash'
import { GoogleOAuthProvider } from '@react-oauth/google';

//TODO: SWITCH TO AXIOS FROM FETCH

function getItem(
    label,
    key,
    icon,
    children,
    type,
  ) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

const EntryPage = (() => {
  console.log(
    "EntryPageWDYR Re-Render! - We don't want this to happen too often."
  );
  //const { tokens } = useTheme();
  const { user } = useAuthenticator((context) => [context.user])
  const [time, setTime] = useState(new Date())
  const [allSites, setAllSites] = useRecoilState(allSitesAtom)
  const [loading, setLoading] = useState(false)
  const [fullscreen,setFullscreen] =useState(false)
  const [items, setItems] = useState([])
  const [recipientShares, setRecipientShares] = useState(allSites['recipientShares'])
  const [currentShareID,setCurrentShareID] = useState(undefined)
  const [acceptShare,setAcceptShare] = useState(false)
  const [acceptLoading,setAcceptLoading] = useState(false)
  const [acceptInitiated,setAcceptInitiated] = useState(false)
  const [rejectLoading,setRejectLoading] = useState(false)
  const [rejectInitiated,setRejectInitiated] = useState(false)
  console.log('Items:',items)
  console.log('All Sites:',allSites)
  const [rootSubmenuKeys, setRootSubmenuKeys] = useState([])
  const messageAttributes = "msgType,message_id,settings,alert_id,ts,message,alertContent,mac,toolType"
  const theme = {
    name: 'classic-theme',
    tokens: {
      colors: {
        brand: {
          primary: {
            10: { value: '#263cab1a' },
            20: { value: '#263cab33' },
            40: { value: '#263cab66' },
            60: { value: '#263cab99' },
            80: { value: '#263cab' },
            90: { value: '#263cab' },
            100: { value: '#263cab' },
          },
          secondary: {
            10: { value: '{colors.neutral.10}' },
            20: { value: '{colors.neutral.20}' },
            40: { value: '{colors.neutral.40}' },
            60: { value: '{colors.neutral.60}' },
            80: { value: '{colors.neutral.80}' },
            90: { value: '{colors.neutral.90}' },
            100: { value: '{colors.neutral.100}' },
          },
        },
        border: {
          primary: { value: '{colors.neutral.40}' },
          secondary: { value: '{colors.neutral.20}' },
          tertiary: { value: '{colors.neutral.10}' },
        },
      },
      radii: {
        small: { value: '2px' },
        medium: { value: '2px' },
        large: { value: '4px' },
        xl: { value: '6px' },
      },
    },
    overrides: [defaultDarkModeOverride],
  };
  useEffect(() => {
    if(_.isEqual(allSites,{})) setItems([]) 
    if(!_.isEqual(allSites.fullscreen,fullscreen)) setFullscreen(allSites.fullscreen)
    if(allSites.repull){
      let tempAllSites = _.cloneDeep(allSites)
      delete tempAllSites['repull']
      console.log('allSites MobileEntry Updating AllSites to ',tempAllSites)
      setAllSites(tempAllSites)
      setTime(new Date())
    }
  }, [allSites]);
  useEffect(() => {
    if(acceptLoading){
      try {
        updateRecipient(user.signInUserSession.idToken.jwtToken,currentShareID,{shareNotify: true, acceptState: true}).then(()=>{
            setAcceptLoading(false)
            setRejectLoading(false)
            setTime(new Date())
        })
      } catch (error) {
        console.log("DELETE ERROR:", error)
      }
    }else{
      if(acceptInitiated){
        setAcceptShare(false)
        setAcceptInitiated(false)
        setCurrentShareID(undefined)
      } 
    }
  }, [acceptLoading,acceptInitiated]);
  useEffect(() => {
    if(rejectLoading){
      try {
        updateRecipient(user.signInUserSession.idToken.jwtToken,currentShareID,{shareNotify: true, acceptState: false}).then(()=>{
            setAcceptLoading(false)
            setRejectLoading(false)
            setTime(new Date())
        })
      } catch (error) {
        console.log("DELETE ERROR:", error)
      }
    }else{
      if(rejectInitiated){
        setAcceptShare(false)
        setRejectInitiated(false)
        setCurrentShareID(undefined)
      } 
    }
  }, [rejectLoading,rejectInitiated]);
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setTime(new Date())
  //   }, 1000 * 60 * 60);

  //   return () => clearInterval(interval)
  // }, []);
  // if(user && _.has(user,'signInUserSession') && _.has(user.signInUserSession,'idToken') && _.has(user.signInUserSession.idToken,'jwtToken'))
  useEffect(() => {
    setLoading(true);
    if(user && _.has(user,'signInUserSession') && _.has(user.signInUserSession,'idToken') && _.has(user.signInUserSession.idToken,'jwtToken')) {
      console.log('USER SIGNED IN and has token:',user)
      getTools({token: user.signInUserSession.idToken.jwtToken}).then(async (data) => {
        if(data) {
          console.log('Site Data:',data)
          let recipientShares = await getRecipientShares({token:user.signInUserSession.idToken.jwtToken}).then(data => {
            console.log('data:',data)
            return data
          })
          let messages = await getMessages(messageAttributes).then(data => {
            console.log('data:',data)
            return data
          })
          let unreadMessages = 0
          if(messages){
            messages.forEach((message) => {   
              if (!message.settings.read) unreadMessages++
          });
          }
          
          let toolToAccept = null
          var menu = [];
          var keys = [];
          var sites = {
            //DB data storage:
            graphData: new Map(),
            graphData10: new Map(),
            graphData100: new Map(),
            graphData1000: new Map(),
            graphDataHour: new Map(),
            graphDataDay: new Map(),
            graphDataMonth: new Map(),
            //Scope storage
            liveScope: new Map(),
            dayScope: new Map(),
            weekScope: new Map(),
            monthScope: new Map(),
            maxScope: new Map(),
            customScope: new Map(),
            recipientShares: recipientShares,
            messages: messages,
            unreadMessages: unreadMessages,
          };
          var tools = [];
          Object.keys(data.items).forEach((tool) => {
            console.log('Current tool:',data.items[tool])

            sites[tool] = data.items[tool];
            tools.push({label:data.items[tool].settings.toolName,key: tool,toolType:data.items[tool].toolType});
            keys.push(tool);
            if(recipientShares && recipientShares.get(tool) && recipientShares.get(tool).recipientSettings.acceptState != true){
              if(currentShareID == undefined){
                setAcceptShare(true)
                setCurrentShareID(tool)
              } 
            }else{
              menu.push(
                data.items[tool]
              );
            }
            
          });
          sites.tools = tools;
          console.log('user, time MobileEntry Updating AllSites to ',sites)
          setAllSites(sites);
          setItems(menu);
          setRootSubmenuKeys(keys);
          setRecipientShares(recipientShares)
        }
        setLoading(false);
      }).catch((err) => {console.log("Error: ", err)});
    }else{
      console.log('NO TOKEN:',user)
    }
  }, [user, time]);

  return (
    <GoogleOAuthProvider clientId="939028926181-bt6hgb62ofkptc3vhdqhd58ihle6p0kj.apps.googleusercontent.com">
      <ThemeProvider theme={theme}>
        <App>
          {!fullscreen?<NavBar menu={<MobileMenu items={items} rootSubmenuKeys={rootSubmenuKeys} loading={loading} />} />:<></>}
          <Authenticator formFields={{signIn:{username:{placeholder:'Enter Your Email',isRequired:true,label:'Email'}},signUp:{username:{placeholder:'Enter Your Email',isRequired:true,label:'Email'}},resetPassword:{username:{placeholder:'Enter Your Email',label:'Email'}}}}>
            {({ signOut, user }) => (
              <>
                <Layout>
                {!fullscreen?<SideBar className="sidebar" menu={<MobileMenu items={items} rootSubmenuKeys={rootSubmenuKeys} loading={loading} />} />:<></>}
                  <Layout.Content className="content">
                    <AppRoutes />
                    <Alert 
                      visible={acceptShare} 
                      setVisible={setAcceptShare} 
                      title="Tool Sharing Request" 
                      loading={acceptLoading || rejectLoading}
                      text={recipientShares && currentShareID? (recipientShares.get(currentShareID).recipientSettings.senderEmailID + " is attempting to share a tool with you"):''} 
                      button={<Button
                        style={{width:"48%"}}
                        isLoading ={acceptLoading}
                        disabled = {rejectLoading}
                        text={'Accept'}
                        variant="primary"
                        onPress={() => {
                          setAcceptLoading(true)
                          setAcceptInitiated(true)
                        }}
                      />}
                      button2={<Button
                        style={{width:"48%"}}
                        isLoading ={rejectLoading}
                        text={'Reject'}
                        disabled = {acceptLoading}
                        variant="primary-transparent"
                        onPress={() => {
                          setRejectLoading(true)
                          setRejectInitiated(true)
                        }}
                      />}
                    />
                  </Layout.Content>
                </Layout>
              </>
            )}
          </Authenticator>
        </App>
      </ThemeProvider>
      </GoogleOAuthProvider>
  );
})
EntryPage.displayName = "EntryPageWDYR";
EntryPage.whyDidYouRender = true;
export default withCookies(EntryPage);
